const BASE_TEMPLATES = [
  { id: 't1', name: 'Standard Consultation', type: 'Consultation', fields: 12, description: 'Full SOAP notes, vitals, and treatment plan entry', lastUsed: 'Mar 18, 2026', usageCount: 248, icon: 'clipboard', color: 'teal', custom: false },
  { id: 't2', name: 'Follow-up Visit', type: 'Follow-up', fields: 8, description: 'Progress check with abbreviated SOAP and status update', lastUsed: 'Mar 19, 2026', usageCount: 186, icon: 'refreshCw', color: 'blue', custom: false },
  { id: 't3', name: 'Treatment Record', type: 'Treatment', fields: 14, description: 'Procedure record with materials, tooth chart, and clinical notes', lastUsed: 'Mar 17, 2026', usageCount: 312, icon: 'tool', color: 'purple', custom: false },
  { id: 't4', name: 'Surgical Procedure', type: 'Surgery', fields: 16, description: 'Pre-op, intraoperative notes, anesthesia, and post-op instructions', lastUsed: 'Mar 15, 2026', usageCount: 67, icon: 'activity', color: 'red', custom: false },
  { id: 't5', name: 'Diagnosis Report', type: 'Diagnosis', fields: 10, description: 'ICD-10 coding, findings, severity, and treatment recommendation', lastUsed: 'Mar 16, 2026', usageCount: 143, icon: 'search', color: 'amber', custom: false },
  { id: 't6', name: 'Prescription', type: 'Prescription', fields: 7, description: 'Drug, dosage, frequency, instructions, and allergy check', lastUsed: 'Mar 18, 2026', usageCount: 201, icon: 'fileText', color: 'green', custom: false },
  { id: 't7', name: 'Imaging / Radiology', type: 'Imaging', fields: 9, description: 'X-ray/CBCT/Pano findings, annotations, and file attachments', lastUsed: 'Mar 14, 2026', usageCount: 159, icon: 'aperture', color: 'violet', custom: false },
  { id: 't8', name: 'Lab Result Entry', type: 'Lab Result', fields: 6, description: 'Lab order tracking, results, pathology notes, and follow-up actions', lastUsed: 'Mar 12, 2026', usageCount: 44, icon: 'flask', color: 'orange', custom: false },
  { id: 't9', name: 'Referral Note', type: 'Referral', fields: 11, description: 'Specialty, reason, urgency, attached records, and follow-up', lastUsed: 'Mar 17, 2026', usageCount: 88, icon: 'send', color: 'teal', custom: false },
  { id: 't10', name: 'Clinical Note', type: 'Note', fields: 4, description: 'Free-form clinical note with tags, visibility, and attachments', lastUsed: 'Mar 19, 2026', usageCount: 97, icon: 'edit', color: 'inkMuted', custom: false }
]

const CUSTOM_TEMPLATES = [
  { id: 'ct1', name: 'Implant Assessment', type: 'Consultation', fields: 18, description: 'Extended implant workup: CBCT review, bone density, prosthetic planning', lastUsed: 'Mar 10, 2026', usageCount: 23, icon: 'clipboard', color: 'teal', custom: true, createdBy: 'Dr. Kvaratskhelia' },
  { id: 'ct2', name: 'Perio Maintenance', type: 'Treatment', fields: 13, description: 'Recall visit: probing, BOP, plaque index, calculus, SRP notes', lastUsed: 'Mar 16, 2026', usageCount: 41, icon: 'tool', color: 'blue', custom: true, createdBy: 'Dr. Lomidze' },
  { id: 'ct3', name: 'Ortho Progress Check', type: 'Follow-up', fields: 9, description: 'Aligner/wire change, measurements, photos, patient compliance', lastUsed: 'Mar 8, 2026', usageCount: 17, icon: 'refreshCw', color: 'purple', custom: true, createdBy: 'Dr. Beridze' }
]

export const templates = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',

  TabInit: { display: 'none', show: (() => { let d = false; return (el, s) => { if (!d) { d = true; Promise.resolve().then(() => s.root.update({ activeTab: 'templates', tplFilter: 'all' })) } return false } })() },

  NavSidebar: {},

  MainContent: {
    flow: 'y', flex: '1', overflow: 'auto',
    TopBar: {},

    ContentArea: {
      flow: 'y', gap: 'B', padding: 'B', flex: '1',
      '@mobileL': { padding: 'A' },

      PageHeader: {
        flow: 'x', align: 'center space-between', flexWrap: 'wrap', gap: 'Z',
        HeaderLeft: {
          flow: 'y', gap: 'X',
          PageTitle: { tag: 'h1', text: 'Record Templates', fontSize: 'C', fontWeight: '700', color: 'inkText', letterSpacing: '-0.02em' },
          PageSubtitle: { text: '10 base templates · 3 custom', fontSize: 'Z', color: 'inkMuted' }
        },
        NewTemplateBtn: {
          tag: 'button', text: '+ Create Custom Template',
          fontSize: 'Z', fontWeight: '600', padding: 'Z A', round: 'A',
          background: 'teal', color: 'ink', border: 'none', cursor: 'pointer'
        }
      },

      StatsRow: {
        flow: 'x', gap: 'A', flexWrap: 'wrap',
        StatBase: {
          flow: 'y', gap: 'X', padding: 'A', round: 'A',
          background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'F',
          StatVal: { text: '10', fontSize: 'C', fontWeight: '700', color: 'teal', letterSpacing: '-0.02em' },
          StatLbl: { text: 'Base Templates', fontSize: 'Y', color: 'inkMuted' }
        },
        StatCustom: {
          flow: 'y', gap: 'X', padding: 'A', round: 'A',
          background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'F',
          StatVal: { text: '3', fontSize: 'C', fontWeight: '700', color: 'purple', letterSpacing: '-0.02em' },
          StatLbl: { text: 'Custom Templates', fontSize: 'Y', color: 'inkMuted' }
        },
        StatUsages: {
          flow: 'y', gap: 'X', padding: 'A', round: 'A',
          background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'F',
          StatVal: { text: '1,545', fontSize: 'C', fontWeight: '700', color: 'green', letterSpacing: '-0.02em' },
          StatLbl: { text: 'Total Uses This Month', fontSize: 'Y', color: 'inkMuted' }
        },
        StatTypes: {
          flow: 'y', gap: 'X', padding: 'A', round: 'A',
          background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'F',
          StatVal: { text: '7', fontSize: 'C', fontWeight: '700', color: 'amber', letterSpacing: '-0.02em' },
          StatLbl: { text: 'Active Record Types', fontSize: 'Y', color: 'inkMuted' }
        }
      },

      FilterBar: {
        flow: 'x', gap: 'Y', flexWrap: 'wrap',
        AllPill: { tag: 'button', text: 'All', padding: 'Y Z', round: 'C', fontSize: 'Y', fontWeight: '600', border: 'none', cursor: 'pointer', background: (el, s) => (s.root.tplFilter || 'all') === 'all' ? 'inkText' : 'inkSurface', color: (el, s) => (s.root.tplFilter || 'all') === 'all' ? 'ink' : 'inkMuted', onClick: (e, el, s) => s.root.update({ tplFilter: 'all' }) },
        BasePill: { tag: 'button', text: 'Base', padding: 'Y Z', round: 'C', fontSize: 'Y', fontWeight: '600', border: 'none', cursor: 'pointer', background: (el, s) => s.root.tplFilter === 'base' ? 'teal.15' : 'inkSurface', color: (el, s) => s.root.tplFilter === 'base' ? 'teal' : 'inkMuted', onClick: (e, el, s) => s.root.update({ tplFilter: 'base' }) },
        CustomPill: { tag: 'button', text: 'Custom', padding: 'Y Z', round: 'C', fontSize: 'Y', fontWeight: '600', border: 'none', cursor: 'pointer', background: (el, s) => s.root.tplFilter === 'custom' ? 'purple.15' : 'inkSurface', color: (el, s) => s.root.tplFilter === 'custom' ? 'purple' : 'inkMuted', onClick: (e, el, s) => s.root.update({ tplFilter: 'custom' }) }
      },

      // ─── BASE TEMPLATES ────────────────────────────
      BaseTplSection: {
        flow: 'y', gap: 'A',
        show: (el, s) => (s.root.tplFilter || 'all') !== 'custom',

        SectionHead: {
          flow: 'x', align: 'center flex-start', gap: 'Z',
          SectionTitle: { text: 'Base Templates', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
          SectionBadge: { tag: 'span', text: '10', fontSize: 'Y', fontWeight: '600', padding: 'X Y', round: 'C', background: 'inkSurface', color: 'inkMuted' }
        },

        BaseTplGrid: {
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: 'A',
          children: BASE_TEMPLATES,
          childrenAs: 'state',
          childExtends: {
            flow: 'y', gap: 'Z', padding: 'A', round: 'A',
            background: 'inkMid', border: '1px solid inkBorder', cursor: 'pointer',

            CardTop: {
              flow: 'x', gap: 'Z', align: 'center flex-start', marginBottom: 'X',
              CardIcon: {
                width: 'C', height: 'C', round: 'Y', flexShrink: '0',
                flow: 'x', align: 'center center',
                background: (el, s) => (s.color || 'teal') + '.12',
                CardIconInner: { extends: 'Icon', icon: (el, s) => s.icon || 'clipboard', width: 'B', height: 'B', color: (el, s) => s.color || 'teal' }
              },
              CardMeta: {
                flow: 'y', gap: 'X', flex: '1',
                CardName: { text: (el, s) => s.name, fontSize: 'Z', fontWeight: '700', color: 'inkText' },
                CardType: { tag: 'span', text: (el, s) => s.type, fontSize: 'Y', fontWeight: '600', color: (el, s) => s.color || 'teal' }
              }
            },

            CardDesc: { text: (el, s) => s.description, fontSize: 'Y', color: 'inkMuted', lineHeight: '1.5', flex: '1' },

            CardFooter: {
              flow: 'x', gap: 'Z', align: 'center space-between', paddingTop: 'Z', borderTop: '1px solid inkBorder', marginTop: 'Y',
              FooterMeta: {
                flow: 'y', gap: 'X',
                FieldCount: { text: (el, s) => (s.fields || 0) + ' fields', fontSize: 'Y', color: 'inkMuted' },
                UsageCount: { text: (el, s) => 'Used ' + (s.usageCount || 0) + 'x', fontSize: 'Y', color: 'inkMuted' }
              },
              FooterActions: {
                flow: 'x', gap: 'Y',
                UseBtn: { tag: 'button', text: 'Use', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'Y', background: 'teal', color: 'ink', border: 'none', cursor: 'pointer' },
                EditBtn: { tag: 'button', text: 'Edit', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'Y', background: 'inkSurface', color: 'inkText', border: '1px solid inkBorder', cursor: 'pointer' }
              }
            }
          }
        }
      },

      // ─── CUSTOM TEMPLATES ──────────────────────────
      CustomTplSection: {
        flow: 'y', gap: 'A',
        show: (el, s) => (s.root.tplFilter || 'all') !== 'base',

        SectionHead2: {
          flow: 'x', align: 'center flex-start', gap: 'Z',
          SectionTitle2: { text: 'Custom Templates', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
          SectionBadge2: { tag: 'span', text: '3', fontSize: 'Y', fontWeight: '600', padding: 'X Y', round: 'C', background: 'purple.12', color: 'purple' }
        },

        CustomTplGrid: {
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: 'A',
          children: CUSTOM_TEMPLATES,
          childrenAs: 'state',
          childExtends: {
            flow: 'y', gap: 'Z', padding: 'A', round: 'A',
            background: 'inkMid', border: '1px solid purple.20', cursor: 'pointer',

            CardTop2: {
              flow: 'x', gap: 'Z', align: 'center flex-start', marginBottom: 'X',
              CardIcon2: {
                width: 'C', height: 'C', round: 'Y', flexShrink: '0',
                flow: 'x', align: 'center center',
                background: (el, s) => (s.color || 'purple') + '.12',
                CardIconInner2: { extends: 'Icon', icon: (el, s) => s.icon || 'clipboard', width: 'B', height: 'B', color: (el, s) => s.color || 'purple' }
              },
              CardMeta2: {
                flow: 'y', gap: 'X', flex: '1',
                CardName2: { text: (el, s) => s.name, fontSize: 'Z', fontWeight: '700', color: 'inkText' },
                CardTypeMeta: {
                  flow: 'x', gap: 'Y', align: 'center flex-start',
                  CardType2: { tag: 'span', text: (el, s) => s.type, fontSize: 'Y', fontWeight: '600', color: (el, s) => s.color || 'purple' },
                  CustomBadge: { tag: 'span', text: 'Custom', fontSize: 'X', fontWeight: '600', padding: 'X Y', round: 'C', background: 'purple.12', color: 'purple' }
                }
              }
            },

            CardDesc2: { text: (el, s) => s.description, fontSize: 'Y', color: 'inkMuted', lineHeight: '1.5', flex: '1' },

            CardFooter2: {
              flow: 'x', gap: 'Z', align: 'center space-between', paddingTop: 'Z', borderTop: '1px solid inkBorder', marginTop: 'Y',
              FooterMeta2: {
                flow: 'y', gap: 'X',
                FieldCount2: { text: (el, s) => (s.fields || 0) + ' fields', fontSize: 'Y', color: 'inkMuted' },
                CreatedBy: { text: (el, s) => 'By ' + (s.createdBy || 'Unknown'), fontSize: 'Y', color: 'inkMuted' }
              },
              FooterActions2: {
                flow: 'x', gap: 'Y',
                UseBtn2: { tag: 'button', text: 'Use', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'Y', background: 'purple', color: 'white', border: 'none', cursor: 'pointer' },
                EditBtn2: { tag: 'button', text: 'Edit', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'Y', background: 'inkSurface', color: 'inkText', border: '1px solid inkBorder', cursor: 'pointer' },
                DupBtn: { tag: 'button', text: 'Duplicate', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'Y', background: 'inkSurface', color: 'inkMuted', border: '1px solid inkBorder', cursor: 'pointer' }
              }
            }
          }
        }
      }
    }
  }
}
